import type { InternalAuditReportRiskAssessmentResultsByRiskIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetInternalAuditReportRiskAssessmentResultsByRiskIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportRiskAssessmentResultsByRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetInternalAuditReportRiskAssessmentResultsByRiskIdArgs = {
  riskId: string;
};

export const useLazyGetInternalAuditReportRiskAssessmentResultsByRiskId =
  createLazyQueryHook<
    UseLazyGetInternalAuditReportRiskAssessmentResultsByRiskIdArgs,
    InternalAuditReportRiskAssessmentResultsByRiskIdResponse,
    GetInternalAuditReportRiskAssessmentResultsByRiskIdQuery
  >({
    trpcQuery: (client, { riskId }) =>
      client.frontend.assessment.internalAuditReportRiskAssessmentResultsByRiskId.query(
        { riskId }
      ),
    mapTrpcDataToGraphQL: (data) => data,
    graphqlDocument:
      GetInternalAuditReportRiskAssessmentResultsByRiskIdDocument,
    graphqlVariables: ({ riskId }) => ({ RiskId: riskId }),
  });
